<template>
  <div class="content-right">
    <column class="column3" :title="props.title" :ele_have_scrollbar="true">
      <template #abc>
        <rowBookCards
          v-for="(item, index) in mydata.courseArr"
          :key="index"
          :info="item"
          path="/layout/list/onlineDetails"
        >
          <template #rowBook>
            <img v-complete:src="item.image" alt="" />
          </template>
        </rowBookCards>
      </template>
    </column>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import column from "@/components/column/index.vue";
import rowBookCards from "@/components/rowBookCards/index.vue";
// import { articleList } from "@/api/home/index.js";
import { getUrlId } from "@/utils/slide.js";
// 推荐列表接口
import { getRecommendList } from "@/api/recommend/index.js";
import { useRoute } from "vue-router";
import { dictKeyWord } from "@/utils/dict.js";
const route = useRoute();
// 
const mydata = reactive({
  courseArr: [],// 图片基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,

});

const props = defineProps({
  title: {
    type: String,
    default: "必学好课",
  },
});

////////////////////////////////////////////
//推荐列表
function getRecommendFn() {
  // 使用标题在字典中进行匹配，得到对应的keyword值
  let keyword = dictKeyWord[props.title];
  getRecommendList({
    keyword: keyword,
    page: 1,
    psize: 10,
    column_key: route.path,
  }).then((res) => {
    mydata.courseArr = res.data.list;
  });
}

getRecommendFn();

////////////////////////////////////////////




//旧接口
// function articleListFN() {
//   articleList({ column_id: getUrlId("/layout/list/onlineLearning") }).then(
//     (res) => {
//       mydata.courseArr = res.data.list;
//     }
//   );
// }

// articleListFN();
</script>

<style scoped lang="scss">
.content-right {
  // border: 1px solid pink;
  width: 320px;
  // 标题
  :deep(.box-column) {
    margin-bottom: 16px;
    .column-title {
      > p {
        display: none;
      }
    }
     .column-content {
      display: flex;
      overflow-x: auto;

      /* 针对webkit内核浏览器 */
      ::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
      }

      /* 针对Firefox */
      scrollbar-width: none; /* Firefox中隐藏滚动条 */

      /* 针对IE和Edge */
      -ms-overflow-style: none; /* IE和Edge中隐藏滚动条 */
    }
  }
  // 内容
  .column3 {
    .row-book:nth-of-type(1) {
      margin-left: 0px;
    }
    .row-book {
      width: 130px;
      margin-left: 16px;
      img {
        width: 130px;
        height: 82px;
        display:block;
        margin-bottom:5px;
        // margin-right: 12px;
      }
      :deep(.box-p) {
        width: 130px;
        // border:1px solid red;
        > p:nth-of-type(1) {
          // white-space: nowrap; /*规定文本不换行**/
          // text-overflow: ellipsis; /**显示省略符号来代表被修剪的文本。*/
          // overflow: hidden;
          font-size: 14px;
          font-weight: 400;
          color: #333333;

          height: 44px;
          line-height: 22px;
          display: -webkit-box;
          -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
          text-overflow: ellipsis; //文本溢出 用省略号显示
          -webkit-line-clamp: 2; //几行
          overflow: hidden;
        }
        > p:nth-of-type(2) {
          display: none;
          // font-size: 14px;
          // font-weight: 400;
          // color: #666666;

          // height: 48px;
          // line-height: 24px;
          // display: -webkit-box;
          // -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
          // text-overflow: ellipsis; //文本溢出 用省略号显示
          // -webkit-line-clamp: 1; //几行
          // overflow: hidden;
        }

        p:hover{
      color:#009DE0;
    }
      }
    }
     .row-book:nth-of-type(1) {
      margin-left: 0px;
    }
  }
}

:deep(.column-content.ele-have-scrollbar){
  height:100%;
  // border:1px solid red;
}
</style>
